import { getSessionStorage } from '../../../utils/enhancedSessionStorage'
import { FEATURES, MODULES } from '../constants/template-info'
import { LocalStorageData } from '../domains/contentful/LocalStorageDataWithExpiry'

import { captureException } from './sentryUtil'

const TEST_KEY = 'test'

export const getFromSessionStorageWithExpiry = (
  key: string,
  isGlobal = true, // Default to global for backward compatibility
): string | null => {
  try {
    const now = new Date()

    // Use enhanced session storage for locale support
    const sessionStorage = getSessionStorage()
    const val = sessionStorage.getItem<string>(key, { isGlobal })

    if (val) {
      const data: LocalStorageData = JSON.parse(val)
      if (now.getTime() > data.expiryInMs) {
        sessionStorage.removeItem(key, { isGlobal })
        return null
      }
      return data.value
    }
  } catch (error) {
    captureException('setInSessionStorageWithExpiry error', {
      module: MODULES.SESSION_STORAGE,
      feature: FEATURES.GET_FROM_SESSION_STORAGE_WITH_EXPIRY,
      extraInfo: {
        // @i18n-ignore
        capturedFrom: 'Get in session storage with expiry function',
        sessionStorageKey: key,
        errorDetail: JSON.stringify(error),
      },
    })
  }
  return null
}

/**
 * Enhanced version with explicit locale support
 * @param key - The key to retrieve
 * @param isGlobal - Whether data is shared across languages (default: false)
 */
export const getFromSessionStorageWithExpiryLocalized = (
  key: string,
  isGlobal = false, // Default to localized for new usage
): string | null => {
  return getFromSessionStorageWithExpiry(key, isGlobal)
}

export const isSessionStorageEnabled = () => {
  console.warn('isSessionStorageEnabled is deprecated. Use EnhancedSessionStorage utility instead.')
  try {
    // Use enhanced session storage for consistency
    const sessionStorage = getSessionStorage()
    sessionStorage.setItem(TEST_KEY, '1', { isGlobal: true })
    sessionStorage.removeItem(TEST_KEY, { isGlobal: true })
    return true
  } catch (error) {
    captureException('Session storage is not enabled', {
      module: MODULES.SESSION_STORAGE,
      feature: FEATURES.GET_FROM_SESSION_STORAGE_WITH_EXPIRY,
    })
    return false
  }
}
